import cn from 'classnames';
import { useTranslation } from 'next-i18next';
import type { FareByType } from '@/api/service/types';
import { formatFare } from '@/lib/common';
import { homeConfig } from './homeConfig';

type Props = {
  item: FareByType;
  type: 'hour' | 'day';
  rentType?: string;
};

export default function FareDescriptionItem({ item, type }: Props) {
  const { t } = useTranslation(homeConfig.i18nNamespaces);
  return (
    <article
      data-test-id="fareDescriptionItem"
      className={cn(
        'flex min-w-[140px] flex-col items-center rounded-xl py-3 px-6',
        {
          'bg-[#E0EEF7]': type === 'hour',
          'bg-[#E5E1FF]': type === 'day',
        }
      )}
    >
      {/* <h4 className="text-subtitle18 text-neutral-90 text-center font-bold">
        {type === 'hour'
          ? t('common:price_table.hourly_rent')
          : rentType === RentType.BIKE
          ? t('common:price_table.daily_rent')
          : ''}
      </h4> */}
      <div className="flex flex-row space-x-8">
        <div className="flex flex-col">
          <p className="text-body14 text-neutral-70 desktop:text-body16 text-center font-semibold">
            {t(`common:price_table.a_${type}`)}
          </p>
          <p className="text-subtitle18 desktop:text-subtitle20 text-center font-bold text-blue-50">
            {formatFare(item?.first_unit_price)}
          </p>
        </div>
        {/* <div className="flex flex-col">
          <p className="text-body14 text-neutral-70 desktop:text-body16 text-center font-semibold">
            {t(`common:price_table.following_${type}`)}
          </p>
          <p className="text-subtitle18 desktop:text-subtitle20 text-center font-bold text-blue-50">
            {formatFare(item?.following_unit_price)}
          </p>
        </div> */}
      </div>
    </article>
  );
}
